import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import type { Navigation } from 'modules/core/lib/navigation/context'
import type { NavigationPaths } from 'modules/core/lib/navigation/context'

import type { Action, Option } from 'modules/payroll_bundle/components/PageHeader/Actions'
import { usePayrollContextlessPolicies } from 'modules/payroll_bundle/hooks/usePayrollContextlessPolicies'

import { PayrollNavigationRight } from './types'

function getOptions(
  navigate: (url: string) => void,
  navigation: Navigation<NavigationPaths>,
  currentPeriodStatus: string | undefined
): Option[] {
  const options = []

  const gotoReport = () => {
    navigate(navigation.reports.fullPath())
    track(trackingEvents.payroll.gotoReports, {
      period_status: currentPeriodStatus,
    })
  }

  options.push({
    title: i18n.t('sidebar.reports'),
    onClick: gotoReport,
  })

  return options
}

function useSupplementsActions(
  navigate: (url: string) => void,
  navigation: Navigation<NavigationPaths>,
  currentPeriodStatus: string | undefined,
  options?: Option[],
  commonAction?: Action
): PayrollNavigationRight {
  const { canUseReports } = usePayrollContextlessPolicies()
  let supplementsOptions = canUseReports
    ? getOptions(navigate, navigation, currentPeriodStatus)
    : []
  if (options) supplementsOptions = supplementsOptions.concat(options)

  return {
    action: commonAction,
    options: supplementsOptions ? supplementsOptions : undefined,
  }
}

export default useSupplementsActions
